const GRAPHQL_API_URL_OLD =
  'https://onetrust-graphql-yoga.onetrusthomeloans.now.sh';
const GRAPHQL_API_URL =
  'https://graphql-onetrust.herokuapp.com/';
const REMOTE_API_URL =
  'https://onetrusthomeloans.com/misc/create_lf_contact.php';

const THANK_YOU_PAGE_URL =
  'https://onetrusthomeloans.com/thank-you-for-your-request/';

const ZAP_URL = 'https://hooks.zapier.com/hooks/catch/5841802/by0vdfy';

export { GRAPHQL_API_URL, REMOTE_API_URL, THANK_YOU_PAGE_URL, ZAP_URL };
